import { EyeIcon, BuildingOffice2Icon } from "@heroicons/react/24/outline";

export default function SocieteCard({ societe, onClick }) {
  return (
    <div
      onClick={onClick}
      className="relative bg-white shadow rounded-xl border border-gray-200 p-4 flex flex-col items-center text-center hover:shadow-md transition group cursor-pointer"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
    >
      {/* Icône entreprise */}
      <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-4">
        <BuildingOffice2Icon className="w-8 h-8 text-gray-500" />
      </div>

      {/* Dénomination sociale */}
      <h2 className="text-lg font-semibold text-gray-800 mb-1">
        {societe.denomination}
      </h2>

      {/* Type (Personne Morale) */}
      <span className="text-sm text-gray-500 mb-2">{societe.type}</span>

      {/* Localisation */}
      <p className="text-sm text-gray-500 mb-1">
        {societe.ville}, {societe.codePostal}
      </p>

      {/* Chiffre d'affaires */}
      {societe.chiffreAffaires && (
        <p className="text-sm text-gray-600">
          CA : {societe.chiffreAffaires.toLocaleString()} €
        </p>
      )}

      {/* Détails spécifiques */}
      <div className="mt-2 text-sm text-gray-600">
        {societe.statutJuridique && <p>Statut : {societe.statutJuridique}</p>}
        {societe.secteurActivite && <p>Secteur : {societe.secteurActivite}</p>}
      </div>

      {/* Statut client */}
      <div className="absolute bottom-4 right-4">
        <span className="inline-flex items-center px-2 py-1 text-xs font-semibold bg-blue-100 text-blue-700 rounded">
          {societe.statut}
        </span>
      </div>

      {/* Overlay consulter */}
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition rounded-xl">
        <div className="bg-white text-gray-800 font-semibold py-2 px-4 rounded-lg shadow hover:bg-gray-200 flex items-center gap-2">
          <EyeIcon className="w-5 h-5" />
          Consulter
        </div>
      </div>
    </div>
  );
}
